import { Badge, Button } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';

type FilterButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  appliedFilters: number;
};

export const FilterButton: React.FC<FilterButtonProps> = React.memo(({ onClick, appliedFilters = 0 }) => {
  const isActive = appliedFilters > 0;

  return (
    <Badge
      badgeContent={appliedFilters > 0 ? appliedFilters : null}
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: '#5083FF',
          color: '#fff',
          fontSize: '12px',
          height: '18px',
          minWidth: '18px',
          borderRadius: '9px',
        },
      }}
    >
      <Button
        variant="text"
        color="primary"
        sx={{
          padding: '0px 16px',
          fontSize: '14px',
          height: '36px',
          backgroundColor: isActive ? '#E7F2FF' : '#F6F6F7',
          '&:hover': {
            backgroundColor: isActive ? '#D4E7FF' : '#E8E8E9',
          },
        }}
        startIcon={
          <VyIcon
            icon="Filter"
            style={{
              transform: 'scale(0.8)',
            }}
          />
        }
        onClick={onClick}
      >
        Filters
      </Button>
    </Badge>
  );
});
